<template>
  <section v-loading="listLoading" class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.groupName" clearable placeholder="群名称" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" clearable placeholder="申请人 ID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="审核状态" @change="list">
            <el-option label="待审" value="pending" />
            <el-option label="已通过" value="approved" />
            <el-option label="已拒绝" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }" class="page-section">
      <el-table :data="results" border stripe height="100%">
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="userId" label="申请人ID" width="100" />
        <el-table-column prop="groupName" label="群名称" min-width="180" />
        <el-table-column prop="memberCount" label="群人数" width="120" />
        <el-table-column prop="contact" label="群主微信号" min-width="160" />
        <el-table-column prop="description" label="群介绍" min-width="260" show-overflow-tooltip />
        <el-table-column label="状态" width="110">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusType(row.status)">
              {{ statusLabel(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核备注" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.reviewNote || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="170">
          <template slot-scope="{ row }">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="审核时间" width="170">
          <template slot-scope="{ row }">
            {{ formatTime(row.auditTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" @click="openEdit(row)">编辑</el-button>
            <el-button size="mini" type="success" @click="audit(row, 'approved')">通过</el-button>
            <el-button size="mini" type="danger" @click="audit(row, 'rejected')">拒绝</el-button>
            <el-button v-if="row.status !== 'pending'" size="mini" @click="audit(row, 'pending')">
              待审
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="editVisible" title="编辑微信群申请" width="680px">
      <el-form :model="editForm" label-width="110px">
        <el-form-item label="群名称">
          <el-input v-model="editForm.groupName" maxlength="128" />
        </el-form-item>
        <el-form-item label="群主微信号">
          <el-input v-model="editForm.contact" maxlength="128" />
        </el-form-item>
        <el-form-item label="群人数">
          <el-input v-model="editForm.memberCount" maxlength="64" />
        </el-form-item>
        <el-form-item label="群介绍">
          <el-input
            v-model="editForm.description"
            type="textarea"
            :rows="4"
            maxlength="1024"
            show-word-limit
          />
        </el-form-item>
        <el-form-item label="审核备注">
          <el-input
            v-model="editForm.reviewNote"
            type="textarea"
            :rows="3"
            maxlength="1024"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "GroupApplicationsAdmin",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      editLoading: false,
      editVisible: false,
      editForm: {
        id: 0,
        groupName: "",
        memberCount: "",
        contact: "",
        description: "",
        reviewNote: "",
      },
      page: {},
      filters: {
        groupName: "",
        userId: "",
        status: "",
      },
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = {
        group_name: this.filters.groupName,
        user_id: this.filters.userId,
        status: this.filters.status,
        page: this.page.page,
        limit: this.page.limit,
      };
      try {
        const data = await this.axios.form("/api/admin/group/list", params);
        this.results = data.results || [];
        this.page = data.page || {};
      } finally {
        this.listLoading = false;
      }
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    statusLabel(status) {
      if (status === "approved") return "已通过";
      if (status === "rejected") return "已拒绝";
      return "待审";
    },
    statusType(status) {
      if (status === "approved") return "success";
      if (status === "rejected") return "danger";
      return "warning";
    },
    formatTime(ts) {
      if (!ts) {
        return "-";
      }
      const d = new Date(ts);
      const pad = (v) => String(v).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
        d.getHours()
      )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    openEdit(row) {
      this.editForm = {
        id: row.id,
        groupName: row.groupName || "",
        memberCount: row.memberCount || "",
        contact: row.contact || "",
        description: row.description || "",
        reviewNote: row.reviewNote || "",
      };
      this.editVisible = true;
    },
    async submitEdit() {
      if (!String(this.editForm.groupName || "").trim()) {
        this.$message.error("请填写群名称");
        return;
      }
      if (!String(this.editForm.contact || "").trim()) {
        this.$message.error("请填写群主微信号");
        return;
      }
      if (!String(this.editForm.memberCount || "").trim()) {
        this.$message.error("请填写群人数");
        return;
      }
      this.editLoading = true;
      try {
        await this.axios.form("/api/admin/group/update", this.editForm);
        this.$message.success("保存成功");
        this.editVisible = false;
        this.list();
      } finally {
        this.editLoading = false;
      }
    },
    async audit(row, status) {
      const actionText = this.statusLabel(status);
      let reviewNote = row.reviewNote || "";

      if (status === "rejected") {
        try {
          const ret = await this.$prompt("可填写拒绝原因，用户侧后续可用于补充信息。", "拒绝申请", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            inputValue: reviewNote,
            inputPlaceholder: "例如：群介绍过少，或联系方式无效",
          });
          reviewNote = ret.value || "";
        } catch (e) {
          return;
        }
      }

      await this.axios.form("/api/admin/group/audit", {
        applicationId: row.id,
        status,
        reviewNote,
      });
      this.$message.success(`${actionText}完成`);
      this.list();
    },
  },
};
</script>

<style scoped lang="scss">
.page-section {
  overflow-y: auto;
}
</style>
